(function () {
  const menu = document.querySelector("[data-menu]");
  document.querySelector("[data-menu-open]")?.addEventListener("click", () => {
    menu?.classList.add("is-open");
    menu?.removeAttribute("hidden");
  });
  document.querySelector("[data-menu-close]")?.addEventListener("click", () => {
    menu?.classList.remove("is-open");
    menu?.setAttribute("hidden", "");
  });

  const gallery = document.querySelector("[data-gallery]");
  const main = document.querySelector("[data-main]");
  let srcs = [];
  let i = 0;
  if (gallery) {
    const thumbs = [...gallery.querySelectorAll("[data-thumb]")];
    srcs = thumbs.map((t) => t.getAttribute("data-src")).filter(Boolean);
    i = Math.max(0, thumbs.findIndex((t) => t.getAttribute("aria-current") === "true"));
    const set = (n) => {
      if (!srcs.length) return;
      i = (n + srcs.length) % srcs.length;
      if (main && srcs[i]) main.src = srcs[i];
      thumbs.forEach((t, idx) => {
        if (idx === i) t.setAttribute("aria-current", "true");
        else t.removeAttribute("aria-current");
      });
    };
    thumbs.forEach((t, idx) => t.addEventListener("click", () => set(idx)));
    const box = document.querySelector("[data-lightbox]");
    const boxImg = box?.querySelector("[data-lightbox-img]");
    const openBox = () => {
      const src = srcs[i] || main?.getAttribute("src");
      if (!box || !boxImg || !src) return;
      boxImg.src = src;
      box.classList.add("is-open");
      box.removeAttribute("hidden");
    };
    const closeBox = () => {
      box?.classList.remove("is-open");
      box?.setAttribute("hidden", "");
    };
    gallery.querySelector("[data-zoom]")?.addEventListener("click", openBox);
    box?.querySelector("[data-lightbox-close]")?.addEventListener("click", closeBox);
    box?.querySelector("[data-lightbox-prev]")?.addEventListener("click", () => {
      set(i - 1);
      if (boxImg && srcs[i]) boxImg.src = srcs[i];
    });
    box?.querySelector("[data-lightbox-next]")?.addEventListener("click", () => {
      set(i + 1);
      if (boxImg && srcs[i]) boxImg.src = srcs[i];
    });
    document.addEventListener("keydown", (e) => {
      if (!box || box.hasAttribute("hidden")) return;
      if (e.key === "Escape") closeBox();
      if (e.key === "ArrowLeft") {
        set(i - 1);
        if (boxImg && srcs[i]) boxImg.src = srcs[i];
      }
      if (e.key === "ArrowRight") {
        set(i + 1);
        if (boxImg && srcs[i]) boxImg.src = srcs[i];
      }
    });
    window.__pdpSetImage = (url) => {
      if (!url || !main) return;
      main.src = url;
      const idx = srcs.indexOf(url);
      if (idx >= 0) {
        i = idx;
        thumbs.forEach((t, n) => {
          if (n === idx) t.setAttribute("aria-current", "true");
          else t.removeAttribute("aria-current");
        });
      }
    };
  }

  const jsonEl = document.querySelector("[data-product-json]");
  const select = document.querySelector("[data-variant-select]");
  const idInput = document.querySelector("[data-variant-id]");
  const add = document.querySelector("[data-add]");
  const priceNow = document.querySelector("[data-price-now]");
  const chips = [...document.querySelectorAll("[data-option-btn]")];
  if (jsonEl && (select || idInput)) {
    let product = {};
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { product = { variants: [] }; }
    const variants = product.variants || [];
    const selected = [];
    chips.forEach((btn) => {
      const idx = Number(btn.getAttribute("data-index"));
      if (btn.classList.contains("is-on")) selected[idx] = btn.getAttribute("data-value");
    });
    const findVariant = (opts) =>
      variants.find((v) => opts.every((val, idx) => !val || v.options[idx] === val));
    const apply = (variant) => {
      if (!variant) return;
      if (select) select.value = String(variant.id);
      if (idInput) {
        idInput.value = String(variant.id);
        idInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
      const opt = select?.selectedOptions?.[0];
      if (priceNow && opt?.dataset.price) priceNow.textContent = opt.dataset.price;
      if (opt?.dataset.image && window.__pdpSetImage) window.__pdpSetImage(opt.dataset.image);
      if (add) {
        add.disabled = !variant.available;
        const gb = document.querySelector(".pdp__gb");
        add.textContent = variant.available ? (gb ? "Reserve kit" : "Add to cart") : "Sold out";
      }
    };
    chips.forEach((btn) => {
      btn.addEventListener("click", () => {
        const idx = Number(btn.getAttribute("data-index"));
        selected[idx] = btn.getAttribute("data-value");
        chips.filter((c) => Number(c.getAttribute("data-index")) === idx)
          .forEach((c) => c.classList.toggle("is-on", c === btn));
        apply(findVariant(selected) || variants.find((v) => v.options[idx] === selected[idx]));
      });
    });
  }

  const qtyInput = document.querySelector("[data-qty-input]");
  document.querySelectorAll("[data-qty]").forEach((btn) => {
    btn.addEventListener("click", () => {
      if (!qtyInput) return;
      qtyInput.value = String(Math.max(1, Number(qtyInput.value || 1) + Number(btn.getAttribute("data-qty"))));
    });
  });

  function parseEnd(value) {
    if (!value) return NaN;
    const trimmed = String(value).trim();
    const direct = Date.parse(trimmed);
    if (!Number.isNaN(direct)) return direct;
    const m = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return Date.parse(`${m[1]}-${m[2]}-${m[3]}T00:00:00+08:00`);
    return Date.parse(trimmed.replace(/(\d+)(st|nd|rd|th)/i, "$1"));
  }

  function renderCountdown(el, end) {
    const ms = end - Date.now();
    if (ms <= 0) {
      el.classList.add("is-done");
      el.innerHTML = "<p>Group buy is open.</p>";
      return false;
    }
    const total = Math.floor(ms / 1000);
    const parts = {
      dd: String(Math.floor(total / 86400)).padStart(2, "0"),
      hh: String(Math.floor((total % 86400) / 3600)).padStart(2, "0"),
      mm: String(Math.floor((total % 3600) / 60)).padStart(2, "0"),
      ss: String(total % 60).padStart(2, "0"),
    };
    Object.keys(parts).forEach((key) => {
      const node = el.querySelector("[data-" + key + "]");
      if (node) node.textContent = parts[key];
    });
    return true;
  }

  document.querySelectorAll("[data-countdown]").forEach((el) => {
    const end = parseEnd(el.getAttribute("data-end"));
    if (Number.isNaN(end)) {
      el.hidden = true;
      return;
    }
    if (!renderCountdown(el, end)) return;
    window.setInterval(() => renderCountdown(el, end), 1000);
  });

  function headingKey(text) {
    return (text || "").replace(/:$/, "").trim().toLowerCase();
  }

  function isHeadingNode(node) {
    if (!node || node.nodeType !== 1 || node.tagName !== "P") return false;
    const strong = node.querySelector("strong");
    if (!strong) return false;
    const all = node.textContent.replace(/\s+/g, " ").trim();
    const head = strong.textContent.replace(/\s+/g, " ").trim();
    return all === head && headingKey(head).length > 0;
  }

  function bucketFor(title) {
    const k = headingKey(title);
    if (["specifications", "specification", "pcb spec", "pcb specs", "plate", "gb details"].includes(k)) return "specs";
    if (["each kit contains", "kit contains", "what's included", "whats included", "included"].includes(k)) return "kit";
    if (["quality expectations", "group buy policies", "note"].includes(k)) return "policy";
    return "notes";
  }

  function esc(s) {
    return String(s)
      .replace(/&/g, "\u0026amp;")
      .replace(/</g, "\u0026lt;")
      .replace(/>/g, "\u0026gt;")
      .replace(/"/g, "\u0026quot;");
  }

  function collectTexts(html) {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    const out = [];
    tmp.querySelectorAll("li").forEach((li) => {
      const t = li.textContent.replace(/\s+/g, " ").trim();
      if (t) out.push(t);
    });
    if (out.length) return out;
    tmp.querySelectorAll("p").forEach((p) => {
      p.innerHTML.split(/<br\s*\/?>/i).forEach((chunk) => {
        const el = document.createElement("div");
        el.innerHTML = chunk;
        const t = el.textContent.replace(/\s+/g, " ").trim();
        if (t) out.push(t);
      });
    });
    if (out.length) return out;
    html.split(/<br\s*\/?>/i).forEach((chunk) => {
      const el = document.createElement("div");
      el.innerHTML = chunk;
      const t = el.textContent.replace(/\s+/g, " ").trim();
      if (t) out.push(t);
    });
    return out;
  }

  function pairFromTexts(texts) {
    const rows = [];
    const rest = [];
    texts.forEach((t) => {
      const i = t.indexOf(":");
      if (i > 0 && i < 42) rows.push([t.slice(0, i).trim(), t.slice(i + 1).trim()]);
      else rest.push(t);
    });
    return { rows, rest };
  }

  function extractLinks(html) {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return [...tmp.querySelectorAll("a")].map((a) => a.outerHTML);
  }

  function buildDescription() {
    const src = document.querySelector("[data-desc]");
    if (!src) return;
    const sections = [];
    let current = { title: "", html: "" };
    const push = () => {
      if (current.html.replace(/<[^>]+>/g, "").trim() || current.title) sections.push(current);
    };
    [...src.childNodes].forEach((node) => {
      if (isHeadingNode(node)) {
        push();
        current = { title: node.textContent.replace(/\s+/g, " ").trim(), html: "" };
      } else if (node.nodeType === 1) {
        current.html += node.outerHTML;
      }
    });
    push();

    const intro = [];
    const specs = [];
    const kit = [];
    const policy = [];
    const notes = [];

    sections.forEach((sec) => {
      if (!sec.title) {
        intro.push(sec.html);
        return;
      }
      const bucket = bucketFor(sec.title);
      const texts = collectTexts(sec.html);
      if (bucket === "specs") {
        const parsed = pairFromTexts(texts);
        parsed.rows.forEach((row) => specs.push(row));
        parsed.rest.forEach((t) => intro.push("<p>" + esc(t) + "</p>"));
        const links = extractLinks(sec.html);
        if (links.length) intro.push("<p>" + links.join(" · ") + "</p>");
      } else if (bucket === "kit") {
        texts.forEach((item) => kit.push(item));
      } else if (bucket === "policy") {
        texts.forEach((item) => policy.push(item));
      } else {
        notes.push("<p><strong>" + esc(sec.title) + "</strong></p>" + sec.html);
      }
    });

    const host = document.createElement("div");
    host.className = "pdp__blocks";

    const introHtml = intro.join("");
    if (introHtml.replace(/<[^>]+>/g, "").trim()) {
      const story = document.createElement("div");
      story.className = "pdp__story rte";
      story.innerHTML = introHtml;
      host.appendChild(story);
    }

    function acc(title, inner, open) {
      if (!inner) return;
      const d = document.createElement("details");
      d.className = "pdp__acc";
      if (open) d.open = true;
      d.innerHTML = "<summary>" + title + "</summary>" + inner;
      host.appendChild(d);
    }

    if (specs.length) {
      const dl = specs.map(([k, v]) => {
        if (k) return "<div><dt>" + esc(k) + "</dt><dd>" + esc(v) + "</dd></div>";
        return "<div><dd>" + esc(v) + "</dd></div>";
      }).join("");
      acc("Specifications", '<dl class="pdp__spec">' + dl + "</dl>", true);
    }
    if (kit.length) {
      acc("In the kit", "<ul>" + kit.map((i) => "<li>" + esc(i) + "</li>").join("") + "</ul>");
    }
    if (policy.length) {
      acc("Quality & group-buy policy", "<ul>" + policy.map((i) => "<li>" + esc(i) + "</li>").join("") + "</ul>");
    }
    if (notes.length) {
      acc("Notes", '<div class="rte">' + notes.join("") + "</div>");
    }

    if (!host.childNodes.length) {
      acc("Details", '<div class="rte">' + src.innerHTML + "</div>", true);
    }
    src.replaceWith(host);
  }

  buildDescription();

  document.querySelectorAll("[data-sort]").forEach((sel) => {
    sel.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", sel.value);
      window.location.assign(url.toString());
    });
  });

  const setHeaderOffset = () => {
    const group = document.querySelector(".shopify-section-group-header-group");
    const header = document.querySelector("#shopify-section-header, .shopify-section-header");
    const el = group || header;
    const h = el ? Math.round(el.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty("--header-offset", h + "px");
  };
  setHeaderOffset();
  window.addEventListener("resize", setHeaderOffset);
})();

